export default __webpack_public_path__ + "static/media/outside.a4129b80.jpg";